<template>
    <div class="about">
        <h1>Select File Name</h1>
        <div class="pl-5">
            <label>Selected File: </label>
            <a @click="download">{{ this.selectedFile[0] ? this.selectedFile[0].filename : '' }}</a>
        </div>
        <v-container fluid>

            <v-data-table :headers="headers" :items="files" :items-per-page="5" class="elevation-1"
                v-model="selectedFile" @click:row="handleFileSelect" :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                }"></v-data-table>
            <v-data-table v-if="!loading" :headers="contentHeaders" :items="contentsConverted" class="elevation-1"
                :items-per-page="25" :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                }"></v-data-table>
        </v-container>
    </div>


</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../store/helpers";
import moment from "moment";

export default {
    data() {
        return {
            headers: [{
                text: 'file name',
                value: 'filename'
            }],
            files: [],
            selectedFile: [],
            filecontent: '',
            contentsConverted: [],
            contentHeaders: [],
            loading: true
        }
    },
    computed: {
        ...mapGetters([
            "campaign",
            "userToken",
            "dashboardersList",
            "isAdmin",
            "campaignsList",
            "selectedDashboard",
            "userRoles"
        ])
    },
    watch: {
        selectedFile(val) {
            this.loading = true;
            this.getBounceBackFile({ filename: val[0].filename, userToken:this.userToken }).then(r => {
                this.filecontent = r;
                const lines = r.split('\r')

                this.contentHeaders = lines[0].split(',').map(e => {
                    return { text: e, value: e }
                })
                const temp = []
                lines.forEach(line => {
                    let a = {}
                    line.split(',').forEach((field, idx) => {
                        a = {
                            ...a,
                            [lines[0].split(',')[idx]]: field
                        }
                    })
                    temp.push(a)
                })
                this.contentsConverted = temp
                this.loading = false
            })
        }
    },
    mounted() {
        this.getBounceBackFilesList({userToken:this.userToken}).then(r => {
            r.files.forEach(f => {
                this.files.push({ filename: f, value: f })
            })
        })
    },
    methods: {
        download() {
            const blob = new Blob([this.filecontent], { type: "text/plain;charset=utf-8" });
            const url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            a.href = url;
            a.download = this.selectedFile[0].filename;
            a.click();
            window.URL.revokeObjectURL(url);

        },
        handleFileSelect(e) {
            this.selectedFile = [e]
        },
        ...mapActions([
            "getBounceBackFilesList",
            "getBounceBackFile"
        ])
    }
}

</script>
